'use client';

import { Menu as MenuType } from '../menu/types';
import Menu from '../menu/Menu';
import MobileMenu from './MobileMenu';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useNavigationData } from '@/lib/utils/navigationHelper/hook';

interface Props {
  leftMenus: Array<MenuType>;
  rightMenus: Array<MenuType>;
  topMenus: Array<MenuType>;
}

export default function MainHeader() {
  const { leftMenus, rightMenus, topMenus } = useNavigationData();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 65);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="px-auto top-auto z-30 mx-auto w-full md:top-0 lg:sticky lg:top-[20px] lg:max-w-container">
      <div className="relative flex flex-col">
        <MobileMenu topMenus={topMenus} mainMenus={leftMenus} />
      </div>
      <div
        className={`navbar hidden h-[100px] px-0 py-2 ${isScrolled ? 'transition-border h-[75px] border border-gray-100 bg-white duration-1000' : ''} rounded-md lg:flex`}
      >
        <div className="navbar-start">
          <div className="ml-[44px]">
            <Link href={'/'} prefetch={false}>
              <div className="h-[51px] w-[132px] logo"></div>
            </Link>
          </div>
        </div>
        <div className="navbar-center">
          <Menu menus={leftMenus} type="main" hoverMainMenuEffect={true} isSticky={isScrolled} />
        </div>
        <div className="navbar-end mr-[44px]">
          <Menu menus={rightMenus} type="search" />
        </div>
      </div>
    </div>
  );
}
